import React from 'react';
import PropTypes from 'prop-types';

import { MCmsNavigation } from '../../molecules';
import { CMS_CONFIG } from '../../../config/cms.config';

export default function OCmsAside({ logOut }) {
	return (
		<aside className="o-aside">
			<MCmsNavigation
				items={CMS_CONFIG.LINKS}
				logOut={logOut}
			/>
		</aside>
	);
}

OCmsAside.propTypes = {
	logOut: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/organisme/cms/_organisme.cms-aside.js